<div class="story-card" [ngClass]="['theme-' + (cardData ? cardData.theme : '0')]" #mainEl>
  <div class="story-card__sizer">
    <div class="story-card__content">
      <ng-container *ngIf="cardData; else customCard" [ngSwitch]="cardData.layout" #cardEls>
          <brt-cover-card *ngSwitchCase="StoryCardLayout.COVER" [card-data]="cardData" [isPreview]="isPreview" [label]="label"></brt-cover-card>
          <brt-content-card *ngSwitchCase="StoryCardLayout.CONTENT" [card-data]="cardData" [current]="current"></brt-content-card>
          <brt-video-card *ngSwitchCase="StoryCardLayout.VIDEO" [card-data]="cardData" [current]="current"></brt-video-card>
          <brt-animation-card *ngSwitchCase="StoryCardLayout.ANIMATION"></brt-animation-card>
          <brt-highlight-card *ngSwitchCase="StoryCardLayout.HIGHLIGHT" [card-data]="cardData" (cardTimeout)="cardTimeout.emit()" [current]="current"></brt-highlight-card>
          <brt-quiz-card *ngSwitchCase="StoryCardLayout.QUIZ" [card-data]="cardData" [current]="current"></brt-quiz-card>
          <brt-quizgame-card *ngSwitchCase="StoryCardLayout.QUIZGAME" [card-data]="cardData" [story-data]="storyData" [current]="current"></brt-quizgame-card>
      </ng-container>

      <ng-template #customCard>
        <ng-content></ng-content>
      </ng-template>
    </div>
  </div>
</div>
